module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/kn-091a5508172f8eee28f23ce17d744ecb.svg";